export abstract class ItemService {
  items: object[] = [];
}
